/*
The MIT License (MIT)

Copyright (c) 2015 instructure-react

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

import React from "react";

export const uncheckedIcon = (
  <svg
    viewBox="0 0 30 20"
    height="100%"
    width="100%"
    style={{ position: "absolute", top: 0 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#8694B1"
      d="M27.667,6.236c-0.949-1.211-2.271-2.15-3.569-3.03
	c-2.729-1.851-5.518-3.119-10.344-3.03c-0.314,0.193-0.87,0.078-1.27,0.175c-0.926,0.225-1.879,0.416-2.723,0.758
	c-2.889,1.17-5.915,3.223-7.683,5.478C1.438,7.404,0.431,7.991,0.083,9.092c-0.167,0.527-0.06,1.333,0.121,1.748
	c0.406,0.93,1.861,2.259,2.601,2.972c1.985,1.914,4.221,3.59,7.018,4.72c0.658,0.266,1.275,0.316,1.997,0.524
	c1.788,0.516,4.593,0.557,6.473,0.058c3.831-1.017,7.643-3.446,9.74-6.119c0.722-0.92,1.697-1.494,2.056-2.797
	C30.549,8.525,28.309,7.053,27.667,6.236z M26.821,10.665c-0.833,1.066-1.856,2.052-2.964,2.855
	c-1.472,1.067-2.797,2.058-4.658,2.797c-0.815,0.323-1.749,0.434-2.662,0.641c-1.45,0.329-3.405-0.02-4.477-0.35
	c-3.236-0.996-5.448-2.51-7.562-4.545c-0.646-0.699-1.29-1.398-1.936-2.098C2.602,9.258,3.866,8.244,4.317,7.81
	c1.93-1.86,3.9-3.456,6.654-4.545c0.712-0.282,1.522-0.403,2.299-0.583c0.352-0.082,0.868,0.044,1.149-0.117
	c5.235,0.042,7.448,2.098,10.404,4.254c0.448,0.326,0.87,0.847,1.21,1.282c0.264,0.337,0.704,0.593,0.968,0.932
	c0.18,0.231,0.295,0.48,0.545,0.642C27.488,10.194,27.074,10.341,26.821,10.665z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#8694B1"
      d="M21.256,9.383c-0.112-0.503-0.038-0.849-0.181-1.282
	c-0.747-2.239-2.407-3.631-4.84-4.254c-0.559-0.143-1.345-0.066-1.996-0.058c-0.335,0.205-1.331,0.29-1.754,0.466
	c-1.48,0.616-2.711,1.927-3.328,3.38c-1.236,2.912,0.514,6.021,2.299,7.167c0.451,0.29,0.908,0.441,1.452,0.641
	c0.765,0.282,1.998,0.589,3.085,0.35c2.324-0.511,3.981-1.707,4.84-3.613C21.144,11.489,21.46,10.303,21.256,9.383z M18.533,11.189
	c-0.507,1.173-1.56,1.894-2.964,2.215c-0.737,0.168-1.511-0.121-1.936-0.292c-1.473-0.593-2.981-2.334-2.178-4.487
	c0.341-0.914,1.157-1.779,2.057-2.156c0.347-0.146,0.879-0.097,1.209-0.292C17.355,6.149,19.711,8.469,18.533,11.189z"
    />
    <line
      fill="none"
      stroke="#8694B1"
      strokeWidth="2"
      strokeMiterlimit="10"
      x1="2.871"
      y1="18.629"
      x2="27.371"
      y2="1.462"
    />
  </svg>
);

export const checkedIcon = (
  <svg
    height="100%"
    width="100%"
    viewBox="0 0 30 20"
    style={{ position: "absolute", top: 0 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FFFFFF"
      d="M27.667,6.236c-0.949-1.211-2.271-2.15-3.569-3.03
	c-2.729-1.851-5.518-3.119-10.344-3.03c-0.314,0.193-0.87,0.078-1.27,0.175c-0.926,0.225-1.879,0.416-2.723,0.758
	c-2.889,1.17-5.915,3.223-7.683,5.478C1.438,7.404,0.431,7.991,0.083,9.092c-0.167,0.527-0.06,1.333,0.121,1.748
	c0.406,0.93,1.861,2.259,2.601,2.972c1.985,1.914,4.221,3.59,7.018,4.72c0.658,0.266,1.275,0.316,1.997,0.524
	c1.788,0.516,4.593,0.557,6.473,0.058c3.831-1.017,7.643-3.446,9.74-6.119c0.722-0.92,1.697-1.494,2.056-2.797
	C30.549,8.525,28.309,7.053,27.667,6.236z M26.821,10.665c-0.833,1.066-1.856,2.052-2.964,2.855
	c-1.472,1.067-2.797,2.058-4.658,2.797c-0.815,0.323-1.749,0.434-2.662,0.641c-1.45,0.329-3.405-0.02-4.477-0.35
	c-3.236-0.996-5.448-2.51-7.562-4.545c-0.646-0.699-1.29-1.398-1.936-2.098C2.602,9.258,3.866,8.244,4.317,7.81
	c1.93-1.86,3.9-3.456,6.654-4.545c0.712-0.282,1.522-0.403,2.299-0.583c0.352-0.082,0.868,0.044,1.149-0.117
	c5.235,0.042,7.448,2.098,10.404,4.254c0.448,0.326,0.87,0.847,1.21,1.282c0.264,0.337,0.704,0.593,0.968,0.932
	c0.18,0.231,0.295,0.48,0.545,0.642C27.488,10.194,27.074,10.341,26.821,10.665z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FFFFFF"
      d="M21.256,9.383c-0.112-0.503-0.038-0.849-0.181-1.282
	c-0.747-2.239-2.407-3.631-4.84-4.254c-0.559-0.143-1.345-0.066-1.996-0.058c-0.335,0.205-1.331,0.29-1.754,0.466
	c-1.48,0.616-2.711,1.927-3.328,3.38c-1.236,2.912,0.514,6.021,2.299,7.167c0.451,0.29,0.908,0.441,1.452,0.641
	c0.765,0.282,1.998,0.589,3.085,0.35c2.324-0.511,3.981-1.707,4.84-3.613C21.144,11.489,21.46,10.303,21.256,9.383z M18.533,11.189
	c-0.507,1.173-1.56,1.894-2.964,2.215c-0.737,0.168-1.511-0.121-1.936-0.292c-1.473-0.593-2.981-2.334-2.178-4.487
	c0.341-0.914,1.157-1.779,2.057-2.156c0.347-0.146,0.879-0.097,1.209-0.292C17.355,6.149,19.711,8.469,18.533,11.189z"
    />
  </svg>
);
